import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NotifyUserService } from '@shared/notify-user.service';
import { of, Subject } from 'rxjs';
import { catchError, concatMap, map, take, takeUntil } from 'rxjs/operators';
import { DataToSendDichiarazione, StatoDichiarazione } from '../../dischiarazione.models';
import { DichiarazioneService } from '../../services/dichiarazione.service';

@Component({
    selector: 'app-dettagli-quadro-rs',
    templateUrl: './dettagli-quadro-rs.component.html',
    styleUrls: ['./dettagli-quadro-rs.component.scss'],
})
export class DettagliQuadroRsComponent implements OnInit, OnDestroy {
    importoPresenteNelleFattureRicevute: number = 0;
    importoNonPresenteNelleFattureRicevute: number = 0;
    statoDichiarazioneTemplate = StatoDichiarazione;
    forfettarioId: number;
    annoRedditi: number;

    private unsubscribeAll = new Subject<void>();

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public dettagliQuadroRs: { statoDichiarazione: number; rigoRsId: number; cellId: string; dataToSendDichiarazione: DataToSendDichiarazione },
        public dialogRef: MatDialogRef<DettagliQuadroRsComponent>,
        private notifyUserService: NotifyUserService,
        private dichiarazioneService: DichiarazioneService
    ) {
        this.forfettarioId = dettagliQuadroRs.dataToSendDichiarazione.forfettarioId;
        this.annoRedditi = dettagliQuadroRs.dataToSendDichiarazione.anno;
    }

    ngOnInit() {
        this.dichiarazioneService
            .getDettagliSingoloQuadroRs(this.forfettarioId, this.annoRedditi, this.dettagliQuadroRs.rigoRsId)
            .pipe(
                map(dettagliQuadroRs => {
                    this.importoPresenteNelleFattureRicevute = dettagliQuadroRs.importoPresenteNelleFattureRicevute;
                    this.importoNonPresenteNelleFattureRicevute = dettagliQuadroRs.importoNonPresenteNelleFattureRicevute;
                }),
                catchError(() => {
                    this.dialogRef.close();
                    return of(null);
                }),
                takeUntil(this.unsubscribeAll)
            )
            .subscribe();
    }

    onSalvaModifiche() {
        this.dichiarazioneService
            .upsertDettagliSingoloQuadroRs(this.forfettarioId, this.annoRedditi, this.dettagliQuadroRs.rigoRsId, this.importoNonPresenteNelleFattureRicevute)
            .pipe(
                map(() => {
                    this.dialogRef.close();
                    this.notifyUserService.showSuccess('Importo aggiornato con successo');
                }),
                concatMap(() => this.dichiarazioneService.getDettagliQuadriRs(this.forfettarioId, this.annoRedditi, { refreshData: true })),
                take(1)
            )
            .subscribe();
    }

    ngOnDestroy(): void {
        this.unsubscribeAll.next();
        this.unsubscribeAll.complete();
    }
}
